var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "230px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('DatePicker', {
    staticStyle: {
      "width": "200px",
      "margin-right": "30px"
    },
    attrs: {
      "type": "year",
      "placement": "bottom-end",
      "placeholder": "选择年份"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: _vm.currentYear,
      callback: function ($$v) {
        _vm.currentYear = $$v;
      },
      expression: "currentYear"
    }
  })], 1), _vm._m(0)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.duizhangdan,
      "height": _vm.tableHeight,
      "loading": _vm.tableLoading,
      "border": ""
    }
  })], 1), _c('DuiZhangDanDrawer', {
    ref: "DuiZhangDanDrawerRef"
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  })]);

}]

export { render, staticRenderFns }